import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer, AuthPanelState } from '@kaseyaitglue/kaseya-ui';
import GuestRoute from '@features/auth/components/GuestRoute';
import { AUTH_ROUTES } from '@features/auth/constants';
import ErrorBoundary from './components/ErrorBoundary';
import '@fortawesome/fontawesome-pro/css/fontawesome.min.css';
import '@fortawesome/fontawesome-pro/css/solid.min.css';
import '@fortawesome/fontawesome-pro/css/regular.min.css';
import '@fortawesome/fontawesome-pro/css/light.min.css';
import './styles/theme.scss';

const Login = lazy(() => import('@features/auth/pages/Login'));
const TFASetup = lazy(() => import('@features/auth/pages/TFASetup'));
const DevLogin = lazy(() => import('@features/auth/pages/DevLogin'));
const SetPassword = lazy(() => import('@features/auth/pages/SetPassword'));
const LoginK1Callback = lazy(() => import('@features/auth/pages/LoginK1Callback'));
const Logout = lazy(() => import('@features/auth/pages/Logout'));
const LogoutK1Callback = lazy(() => import('@features/auth/pages/LogoutK1Callback'));
const IntegrationCallback = lazy(() => import('@features/kaseyaOne/pages/IntegrationCallback'));
const NotFound = lazy(() => import('./pages/NotFound'));
// Inlined so webpack drops the chunk from production builds.
const TestPage = process.env.NODE_ENV !== 'production' ? lazy(() => import('./pages/TestPage')) : null;

const App = () => (
  <>
    <ErrorBoundary>
      <Suspense fallback={null}>
        <Routes>
          <Route path={AUTH_ROUTES.RESET_PASSWORD} element={<SetPassword />} />
          <Route element={<GuestRoute key="guest" />}>
            <Route path={AUTH_ROUTES.LOGIN} element={<Login />} />
            <Route path={AUTH_ROUTES.K1_INITIATE} element={<Login autoStartK1 />} />
          </Route>
          <Route path={AUTH_ROUTES.LOGOUT} element={<Logout />} />
          <Route path={AUTH_ROUTES.LOGOUT_CALLBACK} element={<LogoutK1Callback />} />
          <Route element={<GuestRoute key="pending-tfa" shouldRequirePendingTFA />}>
            <Route path={AUTH_ROUTES.VERIFY} element={<Login initialState={AuthPanelState.VERIFICATION} />} />
            <Route path={AUTH_ROUTES.TFA_SETUP} element={<TFASetup />} />
          </Route>
          <Route path={AUTH_ROUTES.DEV_LOGIN} element={<DevLogin />} />
          <Route path={AUTH_ROUTES.K1_CALLBACK} element={<LoginK1Callback />} />
          <Route path={AUTH_ROUTES.K1_ENABLE_CALLBACK} element={<IntegrationCallback operation="enable" />} />
          <Route path={AUTH_ROUTES.K1_DISABLE_CALLBACK} element={<IntegrationCallback operation="disable" />} />
          {/* TODO: Remove after interceptor testing is complete */}
          {TestPage && <Route path="/v2/test" element={<TestPage />} />}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
    <ToastContainer
      position="bottom-right"
      pauseOnHover
      animation="slide"
      exitVariant={{ x: '100%' }}
      autoHideDuration={10000}
    />
  </>
);

export default App;
